export const siteId = process.env.REACT_APP_BUILD_SITE;

/**
 * Ordena las opciones de tipos de propiedad alfabéticamente por nombre
 * @param {Array} propertyTypeOptions - Array de objetos con las opciones de tipos de propiedad
 * @returns {Array} - Array ordenado alfabéticamente por el campo 'name'
 */
export const getSortedPropertyTypes = propertyTypeOptions => {
  if (!propertyTypeOptions || !Array.isArray(propertyTypeOptions) || propertyTypeOptions.length === 0) {
    return [];
  }
  return [...propertyTypeOptions].sort((a, b) => a.name.localeCompare(b.name));
};
